import React, { useState, useEffect } from "react";
import Carousel from 'react-bootstrap/Carousel'
import { getregister, getbank } from "./../action/user";
import { getpackage } from "./../action/user";
import { getcaste, getcastescount } from "./../action/user";
import { getsliderslist } from "./../action/user";
import ReactPlayer from 'react-player'
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import config from "../../lib/config";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import AOS from 'aos';
import {
  addregister,
  getreligionlist,
  getregislist,
  getcastelist,
  getmaritallist,
  login,
  setCurrentUser,
  getcolorlist,
  getstarlist,
  getzodiaclist,
  getdirectionlist,
  getdistrictslist,
} from '../action/user';
import About from "./About";
import Header from "./header";
import './Homepage.css';
import whyeliteRight from "../../assests/images/whyelite-right.png";
import whyeliteLeft from "../../assests/images/whyelite-left.svg";
import Package from "./packages";
import SuccessStories from "./successstories";
import MahalAds from "./mahalads";
import { calculateAge } from "../../utils/calculateAge";

const useStyles = makeStyles((theme) => ({
  InputLabel: {
    color: "rgb(0,0,0)",
    fontFamily: "Source Sans Pro",
  },
}));

function Homepage() {
  const classes = useStyles();
  const [registers, setRegisters] = useState([]);
  const [religions, setreligion] = useState([]);
  const [districts, setdistricts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [openspinner, setOpenspinner] = useState(false);
  const [castenone, setcastenone] = useState(false);
  const [castes, setCastes] = useState([]);
  const [caste, setCaste] = useState([]);
  const [sliders, setSliders] = useState([]);
  const [banks, setBanks] = useState([]);
  const [idpass, setidpass] = useState('61fe0d29b9938726b92dcb44')

  const [zodiacs, setZodiacs] = useState([]);
  const [stars, setStars] = useState([]);

  const initialFormValue = {
    religion: '61fe0d29b9938726b92dcb44',
    subcaste: "",
    sex: "",
    castename: "",
    maritalname: "",
    date: "",
    month: "",
    year: "",
    age1: "",
    age2: "",
    userid: "",
    city: "",
    educ: "",
    zodiacname: "",
    starname: "",
    membership: "",
  };

  const [formValue, setFormValue] = useState(initialFormValue);

  const onChange = async (e) => {

    e.preventDefault();
    // var testAbdul = convertThis(event,numchar);
    console.log(e.target);
    const { id, value } = e.target;
    // console.log(value);
    let formData = { ...formValue, ...{ [id]: value } };
    setFormValue(formData);
    // console.log(formValue)
    //setValidateError(formData)
    console.log("Testgal", formData)
    var test = await getcastelist(formData.religion);

    const castes = await test.userValue.map((d) => ({
      title: d.castename,
      value: d._id,
    }));
    setCastes(castes);
  };

  const {
    religion,
    subcaste,
    date,
    month,
    year,
    sex,
    castename,
    maritalname,
    age1,
    age2,
    userid,
    city,
    educ,
    zodiacname,
    starname,
    membership,
  } = formValue;
  const [click, setclick] = useState("");
  const [handireason, setHandiReason] = useState("");
  const sexch = [
    { title: "Male", value: "Male" },
    { title: "Female", value: "Female" },
  ];
  const handlechangecastenone = () => {

    if (click == "") {
      setclick("Yes")
    }
    else {
      setclick("")
    }
  }
  const handlechangeHandiReason = () => {
    if (handireason == "") {
      setHandiReason("Yes")
    }
    else {
      setHandiReason("")
    }
  }
  const ages1 = [
    { title: "18", value: "18" },
    { title: "19", value: "19" },
    { title: "20", value: "20" },
    { title: "21", value: "21" },
    { title: "22", value: "22" },
    { title: "23", value: "23" },
    { title: "24", value: "24" },
    { title: "25", value: "25" },
    { title: "26", value: "26" },
    { title: "27", value: "27" },
    { title: "28", value: "28" },
    { title: "29", value: "29" },
    { title: "30", value: "30" },
    { title: "31", value: "31" },
    { title: "32", value: "32" },
    { title: "33", value: "33" },
    { title: "34", value: "34" },
    { title: "35", value: "35" },
    { title: "36", value: "36" },
    { title: "37", value: "37" },
    { title: "38", value: "38" },
    { title: "39", value: "39" },
    { title: "40", value: "40" },
    { title: "41", value: "41" },
    { title: "42", value: "42" },
    { title: "43", value: "43" },
    { title: "44", value: "44" },
    { title: "45", value: "45" },
    { title: "46", value: "46" },
    { title: "47", value: "47" },
    { title: "48", value: "48" },
    { title: "49", value: "49" },
    { title: "50", value: "50" },
  ];

  const ages2 = [
    { title: "19", value: "19" },
    { title: "20", value: "20" },
    { title: "21", value: "21" },
    { title: "22", value: "22" },
    { title: "23", value: "23" },
    { title: "24", value: "24" },
    { title: "25", value: "25" },
    { title: "26", value: "26" },
    { title: "27", value: "27" },
    { title: "28", value: "28" },
    { title: "29", value: "29" },
    { title: "30", value: "30" },
    { title: "31", value: "31" },
    { title: "32", value: "32" },
    { title: "33", value: "33" },
    { title: "34", value: "34" },
    { title: "35", value: "35" },
    { title: "36", value: "36" },
    { title: "37", value: "37" },
    { title: "38", value: "38" },
    { title: "39", value: "39" },
    { title: "40", value: "40" },
    { title: "41", value: "41" },
    { title: "42", value: "42" },
    { title: "43", value: "43" },
    { title: "44", value: "44" },
    { title: "45", value: "45" },
    { title: "46", value: "46" },
    { title: "47", value: "47" },
    { title: "48", value: "48" },
    { title: "49", value: "49" },
    { title: "50", value: "50" },
    { title: "51", value: "51" },
  ];

  const maritals = [
    { title: "First Marriage", value: "Marriage" },
    { title: "Remarriage", value: "Remarriage" },
    { title: 'Remarriage + No children', value: 'RemarriageWithOutChildren' },
    { title: 'Remarriage + Have children', value: 'RemarriageWithChildren' },
  ];

  const educationalQualifications = [
    "BE",
    "BSC",
  ];

  const subCasts = [

  ];

  const getUserData = async () => {

    var test = await getreligionlist();
    // console.log("fdssfdsfdsf", test);
    const option1 = await test.userValue.map((d) => ({
      title: d.religion,
      value: d._id,
    }));
    setreligion(option1);

    var iddddd = idpass
    var test = await getcastelist(iddddd);
    // console.log("fdssfdsfdsf", test);
    const castes = await test.userValue.map((d) => ({
      title: d.castename,
      value: d._id,
    }));
    setCastes(castes);


    var test = await getsliderslist();
    setSliders(test.userValue);
    // console.log(test, "twinkle");
    var test = await getpackage();
    setPackages(test.userValue);
    // console.log(test, "twinkle");
    var test = await getregister();
    // console.log(test, "bdfgfdgdf");
    setRegisters(test.userValue);
    var test = await getcaste();
    setCaste(test.userValue);
    // console.log(test, "twinkle");
    var test = await getbank();
    setBanks(test.userValue);
    // console.log(test, "twinkle");
    var test = await getdistrictslist();
    const districts = await test.userValue.map((d) => ({
      title: d.city,
      value: d._id,
    }));
    setdistricts(districts);

    var test = await getzodiaclist();
    const zodiacs = await test.userValue.map((z) => ({
      title: z.zodiacname,
      value: z._id,
    }));
    setZodiacs(zodiacs);

    var test = await getstarlist();
    const stars = await test.userValue.map((s) => ({
      title: s.starname,
      value: s._id,
    }));
    setStars(stars);
  }

  const handleFormSubmit = async (e) => {
    //console.log("saran");
    e.preventDefault();
    console.log(formValue);
    let reqData = {
      religion,
      subcaste,
      date,
      month,
      year,
      sex,
      castename,
      maritalname,
      age1,
      age2,
      userid,
      city,
      zodiacname,
      starname,
      membership,
    };
    console.log("req", reqData);
    var filterarray =
      "userid=" +
      userid +
      "&religion=" +
      religion +
      "&subcaste=" +
      subcaste +
      "&castename=" +
      castename +
      "&sex=" +
      sex +
      "&maritalname=" +
      maritalname +
      "&age1=" +
      age1 +
      "&age2=" +
      age2 +
      "&city=" +
      city +
      '&castenone=' +
      click +
      '&educ=' +
      educ +
      '&handireason=' +
      handireason +
      '&zodiacname=' +
      zodiacname +
      '&starname=' +
      starname +
      '&membership=' +
      membership;

    window.location = "/freesearch?" + filterarray;
  };

  useEffect(() => {
    //logout(history)
    getUserData()
    // setInterval(()=>setOpenspinner(!openspinner), 3000);
    // or simply just AOS.init();
    AOS.init({
      // initialise with other settings
      duration: 2000
    });
  }, [idpass]);

  // for marquee
  const [mcastes, msetCastes] = useState([])
  const getPacksData = async () => {
    var test = await getcaste();
    msetCastes(test.userValue);
    // console.log(test, "twinkle");
    // alert(openspinner);
    setInterval(setOpenspinner(!openspinner), 200);

  }

  useEffect(() => {
    //logout(history)
    // setOpenspinner(!openspinner);
    getPacksData();
  }, []);


  // to go to top of the page
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isLoggedIn, setIsLoggedIn] = useState();
  const token = localStorage.getItem("user_token");

  useEffect(() => {
    const token = localStorage.getItem("user_token");
    setIsLoggedIn(!!token);  // true if token exists, false otherwise
  }, []);
  console.log('membership: ', membership);
  return (
    <>
      <div className='container-fluid' >
        {/* Banner section */}
        <div className="relative bg-banner-1-new xs-bg-header">
          {/* Banner Image - full screen height */}
          <div
            // src={require('../../assests/images/elite-bg-header.png')}
            // alt="banner"
            style={{
              width: '100%',
              height: '100vh',   // or '50vh' for half the viewport
              objectFit: 'cover',
              display: 'block',
            }}
          />

          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              color: "white",
              textAlign: "center",
              zIndex: 10,
              width: "90%",
            }}
            className="banner-text-h1"
          >
            <h1
              style={{
                lineHeight: "1.4",
                textShadow: "2px 2px 6px rgba(0,0,0,0.5)",
                color: "#ffffff",
                fontWeight: "600",
              }}
              className="banner-content"
            >
              {/* We help you find your perfect partner. */}
              {/* Kalyana Sapthapadhi is Lycoris top matrimony platform, combining tradition and technology to create strong connections. */}
              Find Your Perfect Match
            </h1>
            <h1
              style={{
                fontSize: "4rem",
                fontWeight: "800",
                lineHeight: "1.4",
                textShadow: "2px 2px 6px rgba(0,0,0,0.5)",
              }}
            >
              {/* We provide the best match making service. */}
              {/* Its horoscope intelligence predicts 20 years of love and prosperity. */}
            </h1>
          </div>

          {/* Header floating on top of banner */}
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              width: '100%',
              zIndex: 20,
              background: 'rgba(0,0,0,0.5)',
              overflow: 'hidden',
            }}
          >
            <marquee class="que" tabindex="-1">
              {mcastes.map(post => (
                <a style={{ padding: '20px', paddingBottom: '0px', fontWeight: '800', color: 'white' }} href={"/freesearch?castename=" + post._id}>{post.castename} <span>{"(" + " " + post.registerscount + " " + ")"}</span> </a>
              ))}
            </marquee>
          </div>

          <style jsx>{`
                        @keyframes marquee {
              0 % { transform: translateX(100 %); }
                  100% {transform: translateX(-100%); }
                }
            `}
          </style>
        </div>


        {/* <Carousel interval={1000} keyboard={false} pauseOnHover={true}>
          {sliders.map(post => (
            <Carousel.Item >
              <img className="d-block w-100"
                src={config.API + "/images/user/" + post.banner} />
            </Carousel.Item  >
          ))}
        </Carousel> */}
        {/* <Carousel.Item style={{'height':"450px"}}>  
        <img style={{'height':"450px"}}  
          className="d-block w-100"  
           src={require('../../assests/images/20525home-banner.png')}    />  
                </Carousel.Item>  
              <Carousel.Item style={{'height':"450px"}}>  
              <img style={{'height':"450px"}}  
POSTts/images/32930Banner.png')}   />  
                </Carousel.Item>   */}

        {/* <div>
          <section className="under-banner-title" >
            <div className="text-center">
              <a href="/plandetail"><p>If you wish, we will arrange the marriage by talking to both families through our center.</p></a>
            </div>
          </section>
        </div> */}

        {/* <section className="ourpackages" style={{ background: '#fafbfd', paddingTop: '30px' }} data-aos="fade-up">
          <div className="container">
            <div className="row">
              <div className="title">
                <h2 className="text-center">Membership Plan </h2>
              </div>
            </div>
            <div className="selectpackage" id="selectpackage">
              <div className="row">
                {packages.map(post => (
                  <div className="col-md-3 col-sm-6">
                    <div className="package-boxshadow" data-aos="flip-right">
                      <div className="silver">
                        <h2>{post.packagename}</h2>
                        <div className="pricecircle">
                          <h4><img style={{ height: '20px' }} src={require('../../assests/images/rupee.png')} /></h4>
                          <h1 style={{ fontSize: '35px', fontWeight: '800' }}>{post.amount}</h1>
                          <p>Only</p>
                        </div>
                        <h5>Number of Profiles</h5>
                        <h3>{post.count}</h3>
                        <h4 style={{ marginBottom: '20px', fontWeight: "700", lineHeight: "23px" }}>{post.monthvalidate + " " + "Valid for Months"}</h4>
                        <a className="button" href="#bankdetail">SELECT PACKAGE</a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="w3layouts-footerdesign">
            <div className="footerdesign">
              <img src="{ require('../../assests/images/bg.png') }" alt="" />
            </div>
            <div className="clearfix" />
          </div>
        </section> */}

        <div class="container-min ">
          <div class="row text-center padding-cont">
            <h2 class="col-md-12 col-12 pt-3 font-great-vibes">
              Where Traditions Meet Technology
            </h2>
            <div class="col-md-8 col-12 mx-auto pt-3 xs-small-text1 box-min-width-text1" style={{ fontFamily: 'Poppins' }}>
              <span style={{ fontSize: "28px" }}>
                <strong>
                  Unlock the secrets of your destiny with your horoscope
                </strong>
              </span>
              <br />
              Kalyana Sapthapadhi is Lycoris top matrimony platform, combining tradition and technology
              <br />
              to create strong connections. It's horoscope intelligence predicts love and prosperity.
            </div>
            <div class="col-md-9 col-12 mx-auto pt-5 xs-padd5 box-min-width">
              <div class="row">
                <div class="col-md-3 col-12 box-width">
                  <div class="service-title-txt">5+</div>
                  <div class="xs-small-text">Years of expertise</div>
                </div>
                <div class="col-md-3 col-12 box-width xs-mt10-min">
                  <div class="service-title-txt">10,000+</div>
                  <div class="xs-small-text">Kalyanasapthapathi customers serviced</div>
                </div>
                <div class="col-md-3 col-12 box-width xs-mt10">
                  <div class="service-title-txt">5</div>
                  <div class="xs-small-text">Relationship Managers</div>
                </div>
                <div class="col-md-3 col-12 box-width xs-mt10">
                  <div class="service-title-txt">100%</div>
                  <div class="xs-small-text">Confidential</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="topright-hide" style={{ textAlign: 'left' }}>
          <img src={whyeliteLeft} class="whyelite-left-img" alt="Elite Arrow" />
        </div>
        <div class="container-min container-max1 container-min-ss yt-padding">
          <div class="row">
            <div class="col-md-12 col-12 pt-3 pb-3 text-center xs-pb0">
              <img src={require("../../assests/images/yt-flower-center-img.svg").default} alt="YT center image" />
            </div>
          </div>

          <div class="row">
            <h2 class="col-md-12 col-12 pt-3 pb-3 text-center xs-pb0 font-great-vibes">
              Free Search
            </h2>
          </div>

          <div class="swiper-container swiper-container-YT">
            {/* freesearch */}
            <section id="free-search" className="freee">
              <div className="container">
                <div className="freesubmit">
                  <form className={classes.form} noValidate onSubmit={handleFormSubmit}>
                    <div className="row">
                      <div className="col-md-3">
                        <div class="form-group">
                          <label for="exampleFormControlInput1">Registration Number </label>
                          <input type="text"
                            placeholder="Eg : 12345"
                            className="form-control"
                            onChange={onChange}
                            id="userid"
                            style={{ fontSize: "18px", height: "38px" }}
                            value={userid}
                            name="userid"
                            onkeypress="javascript:convertThis(event);" />
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Gender </label>
                          <select
                            class="form-select drs form-select-lg mb-3"
                            aria-label=".form-select-lg example"
                            value={sex}
                            id="sex"
                            onChange={onChange}
                          >
                            <option value="">Select Gender</option>
                            {sexch.length
                              ? sexch.map((e) => (
                                <option value={e.value}>{e.title}</option>
                              ))
                              : null}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Religion </label>
                          <select
                            class="form-select drs form-select-lg mb-3"
                            aria-label=".form-select-lg example"
                            value={religion}
                            id="religion"
                            onChange={onChange}
                          >
                            <option value="">Select Religion</option>
                            {religions.length
                              ? religions.map((e) => (
                                <option value={e.value}>{e.title}</option>
                              ))
                              : null}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Caste </label>
                          <select
                            class="form-select drs form-select-lg mb-3"
                            aria-label=".form-select-lg example"
                            value={castename}
                            id="castename"
                            onChange={onChange}
                          >
                            <option value="">Select Caste</option>
                            {castes.length
                              ? castes.map((e) => (
                                <option value={e.value}>{e.title}</option>
                              ))
                              : null}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Marital Status</label>
                          <select
                            class="form-select drs form-select-lg mb-3"
                            aria-label=".form-select-lg example"
                            value={maritalname}
                            id="maritalname"
                            onChange={onChange}
                          >
                            <option value="">Marital Status</option>
                            {maritals.length
                              ? maritals.map((e) => (
                                <option value={e.value}>{e.title}</option>
                              ))
                              : null}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">District</label>
                          <select
                            class="form-select drs form-select-lg mb-3"
                            aria-label=".form-select-lg example"
                            value={city}
                            id="city"
                            onChange={onChange}
                          >
                            <option value="">Select district</option>
                            {districts.length
                              ? districts.map((e) => (
                                <option value={e.value}>{e.title}</option>
                              ))
                              : null}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Age </label>
                          <select
                            class="form-select drs form-select-lg mb-3"
                            aria-label=".form-select-lg example"
                            value={age1}
                            id="age1"
                            onChange={onChange}
                          >
                            <option value="">Select From Age</option>
                            {ages1.length
                              ? ages1.map((e) => (
                                <option value={e.value}>{e.title}</option>
                              ))
                              : null}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Age</label>
                          <select
                            class="form-select drs form-select-lg mb-3"
                            aria-label=".form-select-lg example"
                            value={age2}
                            id="age2"
                            onChange={onChange}
                          >
                            <option value="">Select To Age</option>
                            {ages2.length
                              ? ages2.map((e) => (
                                <option value={e.value}>{e.title}</option>
                              ))
                              : null}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Zodiac</label>
                          <select
                            class="form-select drs form-select-lg mb-3"
                            aria-label=".form-select-lg example"
                            value={zodiacname}
                            id="zodiacname"
                            onChange={onChange}
                          >
                            <option value="">Select Zodiac</option>
                            {zodiacs.length
                              ? zodiacs.map((e) => (
                                <option value={e.value}>{e.title}</option>
                              ))
                              : null}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div class="form-group">
                          <label for="exampleFormControlSelect1">Star</label>
                          <select
                            class="form-select drs form-select-lg mb-3"
                            aria-label=".form-select-lg example"
                            value={starname}
                            id="starname"
                            onChange={onChange}
                          >
                            <option value="">Select Star</option>
                            {stars.length
                              ? stars.map((e) => (
                                <option value={e.value}>{e.title}</option>
                              ))
                              : null}
                          </select>
                        </div>
                      </div>

                      <div className="col-md-3" style={{ textAlign: "left", alignSelf: "center", paddingTop: '14px' }}>
                        <label style={{ fontSize: "18px" }}>Caste restriction </label>
                        <FormControlLabel
                          style={{ color: "white !important", fontSize: "20px", marginLeft: "10px" }}
                          control={<Checkbox onChange={() => handlechangecastenone()} name="castenone" style={{ color: "white", paddingTop: '14px' }} />}
                        />
                      </div>

                      <div className="col-md-3" style={{ textAlign: "left", alignSelf: "center", paddingTop: '14px' }}>
                        <label style={{ fontSize: "18px" }}> Physically Challenged </label>
                        <FormControlLabel
                          style={{ color: "white !important", fontSize: "20px", marginLeft: "10px" }}
                          control={<Checkbox onChange={() => handlechangeHandiReason()} name="handireason" style={{ color: "white", paddingTop: '14px' }} />}
                        />
                      </div>
                    </div>
                    <div className="row d-flex justify-content-center">
                      <div className="col-md-3" style={{ alignSelf: "center" }}>
                        <div className="submitzz">
                          <button type="submit" name="search" className="btn btn-danger">Submit</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </section>
          </div>

          <div class="row">
            <div class="col-md-12 col-12 pt-5 pb-3 text-center xs-pb0">
              <img src={require("../../assests/images/yt-flower-center-img.svg").default} alt="YT center image" />
            </div>
          </div>

        </div>
        <div class="topright-hide" style={{ textAlign: 'right' }}>
          <img src={whyeliteRight} class="whyelite-bottom" alt="Elite Arrow" />
        </div>

        {/* number of grooms section */}
        <section className="use-full-links">
          <div className="container">
            <div className="row">
              <div className="">
                <h2 class="font-great-vibes" style={{ margin: '20px' }}>
                  Number of Brides and Grooms</h2>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row" style={{ marginBottom: "30px" }}>
              {caste.map(post => (
                <div className="col-md-3" style={{ textAlign: "left" }}>
                  <div className="caste-name" data-aos="flip-up">
                    <p><span>| </span><a href={"/freesearch?castename=" + post._id}>{post.castename} <span>{"(" + " " + post.registerscount + " " + ")"}</span></a></p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* latest profiles */}
        <div class="topright-hide" style={{ textAlign: 'left' }}>
          <img src={whyeliteLeft} class="whyelite-left-img" alt="Elite Arrow" />
        </div>
        <div class="container-fluid bg-banner-1">
          <div class="row topright-hide">
          </div>
          <div class="container-min">
            <div class="row text-center">
              <h2 class="col-md-12 col-12 pt-3 font-great-vibes">
                Latest Profiles
              </h2>
              <section className="userprofile" data-aos="fade-up" style={{ backgroundColor: "#FFECD6" }}>
                <div className="container">
                  <div className="row">
                    <div className="text-center title">
                      {/* <h2>New Matches</h2> */}
                    </div>
                  </div>
                  <div className="featureprofile owl-carousel owl-theme">
                    <div className="item" style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', justifyContent: 'center' }}>
                      {registers && registers.slice(0, 6).map(post => (
                        <div
                          key={post._id}
                          className="col-md-3 col-sm-6 biseller-column"
                          style={{
                            position: 'relative',
                            borderRadius: '16px',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            width: '280px',
                            height: '380px',
                            backgroundColor: '#fff',
                            display: 'flex',
                            flexDirection: 'column',
                            transition: 'transform 0.3s',
                            border: ' 1px solid #FABC28',
                          }}
                          onMouseEnter={e => {
                            if (!isLoggedIn) {
                              const overlay = e.currentTarget.querySelector('.overlay');
                              if (overlay) {
                                overlay.style.opacity = 1;
                                overlay.style.transform = 'translateY(0)';
                              }
                            }
                          }}
                          onMouseLeave={e => {
                            const overlay = e.currentTarget.querySelector('.overlay');
                            if (overlay) {
                              overlay.style.opacity = 0;
                              overlay.style.transform = 'translateY(100%)';
                            }
                          }}
                          data-aos="flip-right"
                        >
                          <a href={"/batman/" + post._id}>

                            {/* Image */}
                            <img
                              src={
                                post.photopath.length && post.photopath[0]
                                  ? config.API + "/images/user/" + post.photopath[0]
                                  : post.sex === "Male"
                                    ? require('../../assests/images/manz.png')
                                    : require('../../assests/images/womanz.png')
                              }
                              alt={post.mname}
                              style={{
                                width: '100%',
                                height: '260px',
                                objectFit: 'fill',
                                // objectPosition: 'top',
                                display: 'block',
                                marginTop: '10px',
                                borderRadius: '10%'
                              }}
                            />

                            {/* Content */}
                            <div style={{ padding: '12px', color: 'black' }}>
                              <h4 style={{ margin: '0 0 6px 0', fontWeight: '600' }}>
                                {post.mname || "Unknown"}
                              </h4>
                              <h4 style={{ margin: '0', }}>
                                Age: {calculateAge(post.dob)} Yrs
                              </h4>
                            </div>

                            {/* Hover Overlay (controlled by inline JS) */}
                            {!isLoggedIn && (
                              <div
                                className="overlay"
                                style={{
                                  position: 'absolute',
                                  top: 0,
                                  left: 0,
                                  right: 0,
                                  bottom: 0,
                                  background: 'linear-gradient(0deg, rgba(0,0,0,0) 12%, rgba(186,62,62,1) 30%)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: '#ffffff',
                                  fontSize: '18px',
                                  fontWeight: 'bold',
                                  textAlign: 'center',
                                  opacity: 0,
                                  transform: 'translateY(100%)', // Start hidden below
                                  transition: 'transform 0.4s ease, opacity 0.4s ease',
                                  pointerEvents: 'none'
                                }}
                              >
                                Please log in to view profiles
                              </div>
                            )}
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
              <div class="row topright-hide">
              </div>
            </div>
          </div>
        </div>
        <div class="topright-hide" style={{ textAlign: 'right', marginBottom: '10px' }}>
          <img src={whyeliteRight} class="whyelite-bottom" alt="Elite Arrow" />
        </div>

        {/* packages */}
        <div class="topright-hide" style={{ textAlign: 'left' }}>
          <img src={whyeliteLeft} class="whyelite-left-img" alt="Elite Arrow" />
        </div>
        <div>
          <h2 class="font-great-vibes" style={{ margin: '20px' }}>
            Kalyana Sapthapadhi Packages
          </h2>
          <Package style={{ gap: "90px" }} />
        </div>
        <div class="topright-hide" style={{ textAlign: 'right', marginBottom: '10px' }}>
          <img src={whyeliteRight} class="whyelite-bottom" alt="Elite Arrow" />
        </div>

        <section>
          <MahalAds />
        </section>

        <section>
          <SuccessStories />
        </section>

        {/* <section className="bankdetail" id="bankdetail">
          <div className="container">
            <div className="bank">
              <div>
                <h3 className="payonline">PAY ONLINE</h3>
                <div className="row"> */}
        {/* <div className="col-md-6">
                  
                    <img className="logo" src={require('../../assests/images/gp (1).png')} />
                    <p className="pno">Phone Number :  99 4331 5331</p>
                    <div>
                      <h1>QR Code</h1>
                      <img className="logo qrscan" src={require('../../assests/images/qr (1).jpeg')} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <img className="logo" src={require('../../assests/images/phpay (2).png')} />
                    <p className="pno">Phone Number :  99 4331 5331</p>
                    <div>
                      <h1>QR Code</h1>
                      <img className="logo qrscan" src={require('../../assests/images/qr (1).jpeg')} />
                    </div>
                  </div> */}
        {/* <div className="col-md-6">
                    <div className="yeah">
                      <img className="logo" src={require('../../assests/images/gp (1).png')} />
                      <img className="logo" src={require('../../assests/images/phpay (2).png')} />
                      <p className="pno">Phone Number :  76739 46789</p>
                      <p className="pno">Phone Number :  96593 99390</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div>
                      <h1>QR Code</h1>
                      <img className="logo qrscan" src={require('../../assests/images/qr (2).jpeg')} />
                    </div>
                  </div>
                </div>
              </div> */}
        {/* <div className="row">
               
                <h3 className="payonline">PAY ONLINE
                </h3>
              
                <div className="img-pay" ><span ><img className="img-go" src={require('../../assests/images/Goog-Pay.jpg')} style={{ height: '25px' }} /></span><span className="wwww">  Google Pay : {banks.length&&banks[0].bankpno}</span></div>
                <div className="img-pay"><span className="img-come"><img src={require('../../assests/images/phonepe-logo.png')} style={{ height: '25px' }} /></span><span className="wwee">  Phone Pay : {banks.length&&banks[0].bankpno}</span></div>
              </div> */}
        {/* <div className="col-md-12  bankdetails">
                <h1>You can also pay directly in the bank.</h1>
                <h3>Bank Account Details</h3>
                <div className="row">
                  {banks.length && banks.map(el => <div className=" col-md-4 col-sm-10 mx-auto">
                    <div className="item">
                      <div className="card"> */}
        {/* <img src={ require('../assests/images/canarabank.jpg') } alt="" /> */}
        {/* <div className="content match-height">
                          <p><b >BANK</b><span className="dot">:</span><span className="a1a1">{el.bankname}</span></p>
                          <p><b >A/C NAME </b><span className="dot">:</span><span className="a1a1"> {el.accountname}</span></p>
                          <p><b>A/C NO </b><span className="dot">:</span><span className="a1a1"> {el.accountno}</span></p>
                          <p><b>BRANCH</b><span className="dot">:</span><span className="a1a1" style={{ fontSize: "14px" }}> {el.branchname}</span></p> */}
        {/*<p><b>BRANCH CODE </b><span class="dot">:</span><span>253</span></p> */}
        {/* <p><b>IFSC CODE</b><span className="dot">:</span><span className="a1a1"> {el.ifsc_no}</span></p>
                        </div>
                      </div>
                    </div>
                  </div>)}
                </div >
              </div >
            </div >
          </div >
        </section > */}
        <section className="dedede">
          <div className="container">
            <div className="appimage">
              <div className="row">


                <div className="col-md-12 siii">
                  {/* <div>
                    <ReactPlayer className='matrivideo' url='https://www.youtube.com/watch?v=HxtVLHGiMjA' />
                  </div> */}
                  {/* <a href="#" target="_blank"> */}
                  <h3 className="clicking">Click here to download the Kalyana Sapthapadhi App.</h3>
                  {/* </a>
                  <a href="#" target="_blank"> */}
                  {/* <button type="button" class="btn btn-primary fir">Download app</button> */}
                  <img className="logo" style={{
                    maxWidth: '340px',
                    height: '227px',
                    objectFit: 'contain',
                    display: 'block',
                    margin: -'39px auto',
                    marginTop: '-30px',
                    marginBottom: '-30px'
                  }} src={require('../../assests/images/playstore.png')} />
                  {/* </a> */}
                </div>

                {/* <div className="col-md-7"> */}
                {/* <a href="#" target="_blank"> */}
                {/* <img className="logo" src={require('../../assests/images/mobilee.png')} /> */}
                {/* </a> */}
                {/* </div> */}

              </div>
            </div>
          </div>
        </section>


        {/* <Backdrop
        sx={{ color: "#da1599", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openspinner}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}

      </div>

    </>


  )



}

export default Homepage;
